// src/pages/Services.js
import React, { useState } from "react";
import "../index.css";

export default function Services() {
  const [activeAccordion, setActiveAccordion] = useState(null);

  // construit un mailto prérempli (devis)
  const buildMailto = (service) => {
    const to = "contact@hlbk.fr";
    const subject = `Demande de devis — ${service}`;
    const body = [
      `Bonjour Maxime,`,
      ``,
      `Je souhaite un devis pour : ${service}`,
      ``,
      `• Date/horaires :`,
      `• Lieu :`,
      `• Type / formule envisagée :`,
      `• Usage des images (perso/entreprise/web/print) :`,
      ``,
      `Mes coordonnées :`,
      `• Nom :`,
      `• Email :`,
      `• Téléphone :`,
      ``,
      `Merci !`,
      `— Envoyé depuis hlbk.fr`,
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      body
    )}`;
  };

  // mailto spécifique mariage (sans brochure)
  const buildMariageMailto = () => {
    const to = "contact@hlbk.fr";
    const subject = "Mariage — Demande de devis";
    const body = [
      `Bonjour Maxime,`,
      ``,
      `Nous souhaitons recevoir un devis pour notre mariage :`,
      ``,
      `• Date :`,
      `• Lieu :`,
      `• Horaires approximatifs :`,
      `• Nombre d’invités (approx.) :`,
      `• Ce que vous souhaitez couvrir (préparatifs, cérémonie, vin d’honneur, soirée…) :`,
      ``,
      `Nos coordonnées :`,
      `• Prénoms :`,
      `• Email :`,
      `• Téléphone :`,
      ``,
      `Merci !`,
      `— Envoyé depuis hlbk.fr`,
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      body
    )}`;
  };

  const ServiceCard = ({
    img,
    title,
    desc,
    sections,
    ctaLabel = "DEMANDER UN DEVIS",
    ctaHref,
  }) => (
    <article className="service-item service-elevated">
      <img className="svc-thumb" src={img} alt={title} />
      <h2 className="svc-title">{title}</h2>
      <p className="svc-blurb">{desc}</p>

      <div className="service-acc">
        {sections.map((section, idx) => {
          const id = `${title}-${idx}`;
          return (
            <details
              key={id}
              className="accordion"
              open={activeAccordion === id}
              onClick={(e) => {
                e.preventDefault();
                setActiveAccordion(activeAccordion === id ? null : id);
              }}
            >
              <summary>{section.label}</summary>
              <div className="accordion-content">{section.content}</div>
            </details>
          );
        })}
      </div>

      <div className="svc-cta-wrap">
        <a href={ctaHref || buildMailto(title)} className="btn-cta btn-cta-red">
          {ctaLabel}
        </a>
      </div>
    </article>
  );

  return (
    <section className="services-page">
      <div className="services-grid">
        {/* Mariage */}
        <ServiceCard
          img="/images/services/mariage.jpg"
          title="Mariage"
          desc="Revivez l’émotion du jour J avec un reportage discret, vrai et lumineux."
          ctaLabel="DEMANDER UN DEVIS"
          ctaHref={buildMariageMailto()}
          sections={[
            {
              label: "Tarif",
              content: (
                <div className="svc-centered-note">
                  <p style={{ textAlign: "center", margin: 0 }}>
                    <strong>Collections mariage à partir de 850€ TTC</strong>
                  </p>
                  <p
                    style={{
                      textAlign: "center",
                      margin: "10px 0 0",
                      opacity: 0.85,
                    }}
                  >
                    Chaque mariage est unique. Les formules sont ajustées selon la durée, le lieu et
                    vos envies.
                  </p>
                </div>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Reportage discret & naturel</li>
                  <li>Galerie privée</li>
                  <li>Livraison pour web & print</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Séance engagement / Day after — <em>sur demande</em>
                  </li>
                  <li>
                    Livre photo & tirages — <em>sur demande</em>
                  </li>
                  <li>
                    Heure supplémentaire — <em>sur demande</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />

        {/* Portrait */}
        <ServiceCard
          img="/images/services/portrait.jpg"
          title="Portrait"
          desc="Des portraits naturels et soignés — en extérieur ou en studio."
          sections={[
            {
              label: "Tarifs",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Séances extérieur</span>
                    <span className="price-chip">à partir de 150€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Séances studio</span>
                    <span className="price-chip">à partir de 190€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Aucune limite de photos</li>
                  <li>Galerie privée</li>
                  <li>Conseils tenues & lieux</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Tirages — <em>sur demande</em>
                  </li>
                  <li>
                    Album photo — <em>sur demande</em>
                  </li>
                  <li>
                    Déplacement hors Tomblaine — <em>en sus</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />

        {/* Événement */}
        <ServiceCard
          img="/images/services/evenement.jpg"
          title="Événement"
          desc="Anniversaires, baptêmes, soirées privées ou associatives — des images vivantes et sincères."
          sections={[
            {
              label: "Tarif",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Reportage événementiel</span>
                    <span className="price-chip">à partir de 300€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Reportage discret & réactif</li>
                  <li>Galerie privée incluse</li>
                  <li>Livraison HD sécurisée</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Heure supplémentaire — <em>sur demande</em>
                  </li>
                  <li>
                    Tirages / album — <em>sur demande</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />

        {/* Entreprise */}
        <ServiceCard
          img="/images/services/entreprise.jpg"
          title="Entreprise"
          desc="Portraits d’équipe, reportage, valorisation d’espaces & événements pro."
          sections={[
            {
              label: "Formules",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">
                      Demi-journée <span className="duration">— 4h</span>
                    </span>
                    <span className="price-chip">600€ HT</span>
                  </li>
                  <li>
                    <span className="svc-line">
                      Journée complète <span className="duration">— 8h</span>
                    </span>
                    <span className="price-chip">1 100€ HT</span>
                  </li>
                  <li>
                    <span className="svc-line">
                      Deluxe <span className="duration">— 2 jours</span>
                    </span>
                    <span className="price-chip">2 000€ HT</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Images adaptées web & print</li>
                  <li>Galerie sécurisée</li>
                  <li>Couverture d’événements & reportages</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Portraits supplémentaires — <em>sur demande</em>
                  </li>
                  <li>Déplacement inclus jusqu’à 100 km A/R autour de Tomblaine</li>
                  <li>
                    Retouches avancées — <em>sur demande</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />
      </div>
    </section>
  );
}